import { createStore } from "vuex";
import { Product } from "./modules/Product";
import { Notice } from "./modules/Notice";
import { Auth } from "./modules/Auth";
import { Youtube } from "./modules/Youtube";
import { Faq } from "./modules/Faq";
import { Common } from "./modules/Common";
import { Lecture } from "./modules/Lecture";
import { Category } from "./modules/Category";
import { Solution } from "./modules/Solution";
import { Afterservice } from "./modules/Afterservice";
import { Download } from "./modules/Download";
import { Qna } from "./modules/Qna";
import { PC } from "./modules/PraiseComplain";

export default createStore({
    modules: {
        Product,
        Auth,
        Notice,
        Youtube,
        Faq,
        Common,
        Lecture,
        Category,
        Solution,
        Download,
        Afterservice,
        Qna,
        PC,

    },
    state: {},
    getters: {},
    actions: {},
    mutations: {},
});
